import './lib/domSafetyPatch';
import './lib/sentry';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import { createAppRouter } from './lib/appRouter';
import './index.css';

export const createRoot = ViteReactSSG({ routes, customCreateRouter: createAppRouter });
